var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1689_709)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 21,
    r: 21,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2752 15.1L31.3988 11.2236C31.2497 11.0745 31.0634 11 30.877 11C30.6906 11 30.5043 11.0745 30.3552 11.2236L28.1934 13.3855C27.8952 13.6836 27.8952 14.1309 28.1934 14.4291L32.0697 18.3054C32.2188 18.4545 32.4052 18.5291 32.5915 18.5291C32.7779 18.5291 32.9643 18.4545 33.1134 18.3054L35.2752 16.1436C35.5734 15.8454 35.5734 15.3609 35.2752 15.1Z",
    fill: "#132342"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1136 15.5098C26.8154 15.2116 26.3309 15.2116 26.07 15.5098L15.5591 26.0207C15.4473 26.1325 15.3727 26.3188 15.3355 26.5052L15 30.6798C15 30.9034 15.0745 31.127 15.2236 31.2761C15.3727 31.4252 15.5591 31.4998 15.7455 31.4998H15.7827L19.9573 31.2016C20.1436 31.2016 20.2927 31.127 20.4418 30.9779L30.99 20.4298C31.1391 20.2807 31.2136 20.0943 31.2136 19.9079C31.2136 19.7216 31.1391 19.5352 30.99 19.3861L27.1136 15.5098Z",
    fill: "#132342"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1689_709",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1689_709"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1689_709",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenLogo);
export default __webpack_public_path__ + "static/media/pen-logo.669ec1b7983132979d642cc286999fcf.svg";
export { ForwardRef as ReactComponent };